// src/analytics.js
import ReactGA from 'react-ga4';

export const initGA = () => {
    ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID); // Replace with your Measurement ID
};

export const logPageView = (path) => {
    ReactGA.send({ hitType: "pageview", page: path });
};
